import styled from 'styled-components';
import { color, container, fontWeight, spacing } from 'theme';

export const StyledSubnavWrapper = styled.div`
  background-color: ${color('white')};
  width: 100%;
  box-sizing: border-box;
`;

export const StyledSubnavContent = styled.div`
  display: flex;
  align-items: flex-start;
  max-width: ${container('xlMax')};
  padding-left: ${spacing('lg')};
  margin: auto;
  gap: ${spacing('xl')};
  width: 100%;
  box-sizing: border-box;
`;

export const StyledIllustration = styled.div`
  flex-shrink: 0;
  width: clamp(75px, 5vw, 100px);
  height: 100px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const StyledIntro = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  flex-shrink: 0;
  width: clamp(150px, 20vw, 350px);
`;

export const StyledIntroTitle = styled.h3`
  font-family: inherit;
  font-weight: ${fontWeight('bold')};
  font-size: 23px;
  line-height: 28px;
  color: ${color('midnight_800')};
  margin: 0;
  white-space: pre-wrap;
`;

export const StyledIntroDesc = styled.p`
  font-family: inherit;
  font-weight: ${fontWeight('regular')};
  font-size: 16px;
  line-height: 24px;
  color: #616161;
  margin: 0;
  white-space: pre-wrap;
`;

export const StyledCtaButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${spacing('xs')};
  height: 32px;
  padding: 0 ${spacing('sm')};
  border: 1px solid ${color('midnight_800')};
  border-radius: 8px;
  background: transparent;
  color: ${color('midnight_800')};
  font-family: inherit;
  font-weight: ${fontWeight('bold')};
  font-size: 13.33px;
  text-transform: uppercase;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: ${color('midnight_800')};
    color: ${color('white')};
  }

  svg {
    font-size: 16px;
  }
`;

export const StyledGroupsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${spacing('xl')};
`;

export const StyledGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('sm')};
  align-items: flex-start;
  flex-shrink: 0;
  width: clamp(0px, 15vw, 250px);
`;

export const StyledGroupTitle = styled.h4`
  font-family: inherit;
  font-weight: ${fontWeight('bold')};
  font-size: 20px;
  line-height: 24px;
  color: ${color('midnight_800')};
  margin: 0;
`;

export const StyledMenuItem = styled.div`
  display: flex;
  gap: ${spacing('xs3')};
  align-items: flex-start;
  overflow: hidden;
  text-decoration: none;
`;

export const StyledMenuIcon = styled.div`
  display: flex;
  height: 20px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${color('midnight_300')};
  font-size: 16px;
`;

export const StyledMenuLink = styled.a`
  font-family: inherit;
  font-weight: ${fontWeight('regular')};
  font-size: 16px;
  line-height: 20px;
  color: ${color('emerald_750')};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
